<!--  -->
<template>
<transition name="el-zoom-in-top">
<div style="display:flex;justify-content: center;height:90%" v-show="show">
  <el-form ref="form" :rules="rules" :model="data" label-width="100px" style="width:500px">
    <el-form-item label="id:" style="display:none">
      <el-input v-model="data.id" :disabled="true"></el-input>
    </el-form-item>
    <el-form-item label="背景图:" prop="backImg">
      <s-upload-img :getImageUrl="getBackImg" :url="data.backImg"></s-upload-img>
    </el-form-item>
    <el-form-item label="电话号码:" prop="telephone">
    <el-input v-model="data.telephone" clearable></el-input>
    </el-form-item>
     <el-form-item label="地址:" prop="address">
    <el-input v-model="data.address" clearable></el-input>
    </el-form-item>
     <el-form-item label="手机号码:" prop="mobilePhone">
    <el-input v-model="data.mobilePhone" clearable></el-input>
    </el-form-item>
     <el-form-item label="邮箱:" prop="email">
    <el-input v-model="data.email" clearable></el-input>
    </el-form-item>
    <el-form-item label="加盟二维码:" prop="qrCode">
      <s-upload-img :getImageUrl="getQRImg" :url="data.qrCode"></s-upload-img>
    </el-form-item>
    <el-button style="margin-left:100px" type="primary" @click="submit('form')" >更新加盟信息</el-button>
  </el-form>
</div>
</transition>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import sUploadImg from '@/components/SingleImgUpload'
import {insert,query,update} from '@/api/admin/franchise.js'
export default {
//import引入的组件需要注入到对象中才能使用
components: {sUploadImg},
data() {
  // let validatePhone = (rule,value,callback)=>{
  //   if(value==''){
  //     callback(new Error('手机号不能为空!'))
  //   }
  //   if(!/^1[123456789]\d{9}$/.test(value)){
  //     callback(new Error('手机号不正确!'))
  //   }
  //   callback()
  // }
//这里存放数据
return {
  show:false,
  data:{
    id:"",
    backImg:"",
    telephone:"",
    address:"",
    mobilePhone:"",
    email:"",
    qrCode:""},
  rules:{
    telephone:[
      {required:true,message:"电话号码不能为空",trigger:'blur'},
      {min:5,message:"长度要大于5",trigger:'blur'}
    ],
    address:{required:true,message:"地址不能为空",trigger:'blur'},
    // mobilePhone:{validator:validatePhone,trigger:'blur'},
    mobilePhone:{required:true,message:"电话号码不能为空",trigger:'blur'},
    email:[
      {required:true,message:"邮箱不能为空",trigger:'blur'},
      {type:"email",message:"邮箱格式不正确",trigger:'blur'}
    ],
    backImg:{required:true,message:"背景图不能为空",trigger:'blur'},
    qrCode:{required:true,message:"二维码不能为空",trigger:'blur'}
  }
};
},
//监听属性 类似于data概念
computed: {

},
//监控data中的数据变化
watch: {},
//方法集合
methods: {
  getBackImg(img){
    this.data.backImg = img;
  },
  getQRImg(img){
    this.data.qrCode = img;
  },
  submit(name){
    let _this = this;
    this.$refs[name].validate((valid)=>{
                      console.log(valid)
      if(valid){
        let result;
        if(_this.data.id!=""){
          result= update(_this.data)
        }else{
          result = insert(_this.data)
        }
        result.then(({code})=>{
             if(code!=200){
              this.$message.error("更新数据失败!")
             }else{
              this.$message.success("更新数据成功!")
              _this.getData()
             }
          },()=>{
            this.$message.error("更新数据失败!")
          })
      }else{
        this.$message.info("有信息格式错误或者空缺")
        return false;
      }

    })
  },
  getData(){
      query().then(({code,data})=>{
          if(code!=200){
            return;
          }
          this.data = data;
      },()=>{
        this.$message.error('加盟信息获取失败');
      })
  }
},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
 this.show=true
 this.getData()
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
/** scoped 表示 样式自在当前组件有效*/
//@import url(); 引入公共css类
.el-upload--picture-card:first{
  width:200px
}
li.el-menu-item{
  font-size:20px
}

</style>